import React from 'react';
import type { FC, PropsWithChildren } from "react";

type ModalFormProps = PropsWithChildren<{
  style?: React.CSSProperties;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  customClass?: string;
  id?: string | undefined;
}>;

const ModalForm: FC<ModalFormProps> = (props) => {
  return (
    <form
      className={`modalContainer__form ${props.customClass || ""}`}
      style={props.style}
      onSubmit={props.onSubmit}
      id={props.id}
    >
      {props.children}
    </form>
  );
};

export default ModalForm;
